import { connect } from 'react-redux';
import EntryItem from 'components/EntryItem/index';
import { entryDelete, entriesUpdate } from 'data/actions';


const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleDelete: (entry, tags) => { dispatch(entryDelete({ ...entry, tags })) },
    toggleIsRead: (entry) => {
      const isRead = !entry.isRead;
      const dateRead = isRead ? new Date() : '';
      dispatch( entriesUpdate([
        {id: entry.id, data: {isRead, dateRead }}
      ]));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntryItem);



// WEBPACK FOOTER //
// ./src/containers/UpdatableEntryItem.js